import { TeamMember } from 'lib/services/TeamMemberService';
import TertiaryHeroBanner from '@/components/Sections/Banners/TertieryHeroBanner';
import { useMemo } from 'react';

export const TeamMemberBanner: React.FC<{ teamMemberData: TeamMember; pageTheme?: string }> = ({
  teamMemberData,
  pageTheme,
}) => {
  const bannerBackground =
    pageTheme?.toLowerCase() === 'financialfairness'
      ? 'background-secondary'
      : 'background-primary';

  const tertiaryHeroBannerProps = useMemo(
    () => ({
      fields: {
        title: {
          value: `${teamMemberData.firstName?.value || ''} ${teamMemberData.lastName?.value || ''}`,
        },
        subtitle: { value: teamMemberData.jobTitle?.value || '' },
      },
      rendering: {
        params: {
          background: bannerBackground,
        },
        componentName: 'TertiaryHeroBanner',
      },
    }),
    [
      bannerBackground,
      teamMemberData.firstName?.value,
      teamMemberData.jobTitle?.value,
      teamMemberData.lastName?.value,
    ]
  );
  return <TertiaryHeroBanner {...tertiaryHeroBannerProps} />;
};
